{
  "title": "Internationalization Example",
  "password": "Password",
  "job": "Job",
  "default_timezone": "Default current device time zone",
  "time_range": "Time range:",
  "front_end_engineer": "Front-end Engineer",
  "back_end_engineer": "Back-end Engineer",
  "responsive_title": "Responsive Example",
  "responsive_hint": "Resize the browser window — the current breakpoint highlights automatically (pure CSS, no JS)",
  "responsive_section_indicator": "Current Breakpoint",
  "responsive_section_grid": "Responsive Layout Demo",
  "responsive_grid_hint": "Mobile: full-width sidebar + 1-col cards → Pad: collapsed sidebar + 2-col cards → PC: full sidebar + 3-col cards",
  "responsive_sidebar": "Sidebar",
  "responsive_card_n": "Card {{n}}",
  "responsive_section_reference": "Usage Example"
}
